export default __webpack_public_path__ + "static/media/TuesdayRingRing.5b3d6e9b.png";